import { useContext } from 'react';
import ThemeContext from './ThemeContext';

export * from './ThemeProvider';
export * from './ThemeContext';

export function useTheme() {
  return useContext(ThemeContext);
}
